// removed by extract-text-webpack-plugin
module.exports = {"base":"EmptyList_base--1VNzy","holder":"EmptyList_holder--1ut3x","title":"EmptyList_title--28AhE","message":"EmptyList_message--3MMst","button":"EmptyList_button--2gw7S"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/EmptyList/EmptyList.css
// module id = 1757
// module chunks = 16